// import React from "react";
// import { Box } from "@mui/material";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/autoplay";
// import "./Banner.css"; // 🟡 custom styles for dots
// import "swiper/css/pagination";

// const BannerCarousel = ({
//   images = [],
//   height = { xs: "200px", sm: "300px", md: "500px", lg: "600px" },
// }) => {
//   return (
//     <Swiper
//       modules={[Autoplay, Pagination]}
//       autoplay={{ delay: 3000, disableOnInteraction: false }}
//       loop={true}
//       pagination={{ clickable: true }}
//       style={{ width: "100%", height: "100%" }}
//     >
//       {images.map((img, index) => (
//         <SwiperSlide key={index}>
//           <Box
//             sx={{
//               width: "100%",
//               height: height,
//               backgroundImage: `url(${img})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               backgroundRepeat: "no-repeat",
//             }}
//           />
//         </SwiperSlide>
//       ))}
//     </Swiper>
//   );
// };

// export default BannerCarousel;
import React from "react";
import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "./Banner.css"; // your custom dot styles
import "swiper/css/pagination";

const BannerCarousel = ({
  images = [],
  height = { xs: "200px", sm: "300px", md: "500px", lg: "650px" },
}) => {
  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
      pagination={{ clickable: true }}
      style={{ width: "100%" }} // keep width here
    >
      {images.map((img, index) => (
        <SwiperSlide key={index}>
          <Box
            sx={{
              width: "100%",
              height: height, // now it will work responsively!
              backgroundImage: `url(${img})`,
              backgroundSize: {
                xs: "contain",
                sm: "contain",
                md: "cover",
                lg: "cover",
              },
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default BannerCarousel;
